export type AnswerOption = {
  letter: string;
  label: string;
};

function parseSelectionLetters(selection: string): string[] {
  const trimmed = selection.trim();
  if (trimmed === '') {
    return [];
  }

  if (trimmed.includes(',')) {
    const letters = trimmed
      .split(',')
      .map((letter) => letter.trim().toUpperCase());

    if (letters.some((letter) => !/^[A-E]$/.test(letter))) {
      return [];
    }

    return letters;
  }

  const compact = trimmed.replace(/\s+/g, '').toUpperCase();
  if (!/^[A-E]+$/.test(compact)) {
    return [];
  }

  return [...compact];
}

function dedupeLettersPreservingOrder(letters: string[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];

  for (const letter of letters) {
    if (!seen.has(letter)) {
      seen.add(letter);
      result.push(letter);
    }
  }

  return result;
}

export function formatSelectionDisplay(selection: string): string {
  return dedupeLettersPreservingOrder(parseSelectionLetters(selection)).join(
    ', ',
  );
}

export function selectionsAreEquivalent(a: string, b: string): boolean {
  const lettersA = dedupeLettersPreservingOrder(
    parseSelectionLetters(a),
  ).sort();
  const lettersB = dedupeLettersPreservingOrder(
    parseSelectionLetters(b),
  ).sort();

  return (
    lettersA.length === lettersB.length &&
    lettersA.every((letter, index) => letter === lettersB[index])
  );
}

export function formatSelectionFromLetters(letters: string[]): string {
  return [...letters].sort().join(', ');
}
